<template>
	<v-checkbox
					v-bind="$attrs"
					v-on="$listeners"
					color="accent"
					:name="name"
					:data-tabordername="tabOrderName || name"
					@keydown="$emit('keydown', $event)"
					@keydown.native="$checkForTabOrderEvent($event)"
					@keyup="$emit('keyup', $event)"
					ref="field"
					autocomplete="off"
					dense
					:input-value="value"
					@change="(value) => $emit('input', value)"
					:autofocus="$autofocus"
	>
		<template v-slot:label="">
			<slot name="label"></slot>
		</template>
	</v-checkbox>
</template>

<script>

import {mobileAppAutofocusMixin} from '../mixins/mobileApp/mobileAppAutofocusMixin.js';

export default {
	name: 'SimpleCheckbox',

	mixins: [mobileAppAutofocusMixin],

	methods: {
		focus() {
			if(this.isWebApp) {
				this.$refs.field.$refs.input.focus();
			}
		},

		blur() {
			this.$refs.field.$refs.input.blur();
		},
	},

	props: ['name', 'value', 'tabOrderName'],
}
</script>

<style scoped>

</style>
